/* src/app/pages/ui-kit/components/tag-view/tag-view.component.scss */
.tag-view {
  padding: 20px;
}
.tag-view h2 {
  margin-bottom: 20px;
  color: var(--text-color);
}
.tag-view .section {
  margin-bottom: 30px;
}
.tag-view .section h3 {
  margin-bottom: 15px;
  color: var(--text-color-secondary);
  font-weight: 600;
}
.tag-view .section .tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
/*# sourceMappingURL=tag-view.component.css.map */
